var _this = this,
    _jsxFileName = "/Users/muhannad/open-source/skip-links/src/index.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import './index.css';

var LinkItem = function LinkItem(_ref) {
  var to = _ref.to,
      title = _ref.title,
      restProps = _objectWithoutPropertiesLoose(_ref, ["to", "title"]);

  return /*#__PURE__*/React.createElement("li", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement("a", _extends({
    href: "#" + to,
    className: "c-links__item"
  }, restProps, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7,
      columnNumber: 5
    }
  }), title));
};

LinkItem.propTypes = process.env.NODE_ENV !== "production" ? {
  title: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired
} : {};

var SkipLinks = function SkipLinks(_ref2) {
  var links = _ref2.links;
  var hasLinks = links && links.length;

  if (hasLinks) {
    return /*#__PURE__*/React.createElement("section", {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 23,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-links",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 24,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement("h2", {
      className: "u-vs-hidden",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 25,
        columnNumber: 11
      }
    }, "Accessibility links"), /*#__PURE__*/React.createElement("ul", {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 27,
        columnNumber: 11
      }
    }, links.map(function (link) {
      return /*#__PURE__*/React.createElement(LinkItem, _extends({
        key: link.title
      }, link, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 29,
          columnNumber: 33
        }
      }));
    }))));
  }

  return null;
};

SkipLinks.propTypes = process.env.NODE_ENV !== "production" ? {
  links: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired
  })).isRequired
} : {};
export default SkipLinks;